import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading } from '@gull';
import Ticket from "../../../app/views/Pdf/Ticket"
import TicketSupplement from "../../../app/views/Pdf/TicketSupplement"
import { BlobProvider } from '@react-pdf/renderer';
import useLoadPublicTicket from './useLoadPublicTicket';

const PublicVisualTicket = ({id,token}) => {
    const t = useTranslate();
    const [loading,ticketDetail,section,companyInfos,moduleInfos,pointsFidelite,error404] = useLoadPublicTicket(id, token)

    if(loading){
        return(
            <Loading></Loading>
        )
    }

    if(error404 || Object.keys(ticketDetail).length==0){
        return(
            <div className="not-found-wrap text-center">
                <h1 className="text-60">404</h1>
                <p className="text-36 subheading mb-3">Error!</p>
                <p className="mb-5 text-muted text-18">
                    {t('error404Msg')}
                </p>
            </div>
        )
    }

    let digit = (companyInfos.advanceparams && companyInfos.advanceparams.hasOwnProperty('ventilation_espece') && companyInfos.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let totalAchat = 0
    let totaltgc = {}
    ticketDetail.ticket_detail.forEach(item=>{
        totalAchat+=item.prix_remise
        if(item.tgc!=0){
            if(totaltgc[item.tgc]){
                totaltgc={...totaltgc,[item.tgc]:totaltgc[item.tgc]+=item.prix_remise}
            }else{
                totaltgc={...totaltgc,[item.tgc]:item.prix_remise}
            }
        }
    })
    totalAchat=+totalAchat.toFixed(digit)

    let tgcForTicketPdf={}
    Object.entries(totaltgc).forEach(([tgcName,montant])=>{
        let coef = +tgcName / 100 + 1
        let totalAmountTgc = (digit==0) ? +montant - (Math.round(+montant / +coef)) : Math.round((+montant - (Math.round((+montant / +coef)*100)/100))*100)/100
        tgcForTicketPdf[tgcName] = totalAmountTgc
    })
    let tgcTotal = 0
    Object.entries(tgcForTicketPdf).forEach(([key,value])=>
        tgcTotal+=value
    )

    const supplement_list_params = moduleInfos.params?.article?.params?.supplement_list
    const TicketComponent = supplement_list_params ? TicketSupplement : Ticket

    return(
        <div className='m-3'>
            <BlobProvider
                document={
                    <TicketComponent
                        thisShop={section}
                        ticketPdf={ticketDetail}
                        t={t}
                        devise={companyInfos.devise}
                        digit={digit}
                        totalAchat={totalAchat}
                        tgcTotal={tgcTotal}
                        tgcForTicketPdf={tgcForTicketPdf}
                        pointsFidelite={pointsFidelite}
                        moduleParam={moduleInfos}
                        authParam={{company:companyInfos}}
                    />
                }
            >
                {({ url, loading:pdfLoading }) => (
                    pdfLoading ?
                        <Loading></Loading>
                    :
                        <iframe
                            src={url}
                            width="100%"
                            height="1000px"
                            title="Aperçu du ticket"
                            style={{ border: 'none', marginTop: '20px' }}
                        ></iframe>
                )}
            </BlobProvider>
        </div>
    )
}

export default PublicVisualTicket;